function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faMapMarker, faMapMarked, faList, faCompass, faBook, faTasks, faUsers, faCogs, faIdCard } from '@fortawesome/free-solid-svg-icons';
import './MobileNavigation.css';

var MobileNavigation = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MobileNavigation, _React$PureComponent);

  function MobileNavigation(props) {
    var _this;

    _classCallCheck(this, MobileNavigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MobileNavigation).call(this, props));
    _this.state = {
      collapsed: true,
      isApp: window.cordova !== undefined
    };
    return _this;
  } //TODO: SETTINGS PANEL, FAVORITES PANEL, RIDERS PANEL FOR STATS ETC


  _createClass(MobileNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          app = _this$props.app,
          searchMode = _this$props.searchMode,
          activePanelIndex = _this$props.activePanelIndex,
          width = _this$props.width;
      var isApp = this.state.isApp;
      var numMapTabs = window.BackgroundGeolocation ? 3 : 2;
      var numPanels = 2;
      var numTabs = numMapTabs + numPanels;
      var tabWidth = width / numTabs;
      var marginLeft = activePanelIndex === 0 ? searchMode === 'location' ? 0 : searchMode === 'track' ? tabWidth : 2 * tabWidth : (activePanelIndex - 1) * tabWidth + (numTabs - numPanels) * tabWidth; // <div className={`ripple btn ${activePanelIndex === 4 ? 'active' : ''}`} onClick={(e) => app.setActivePanelIndex(4)}>
      //   <FontAwesomeIcon icon={faCogs} />
      // </div>
      // <div className={`ripple btn ${activePanelIndex === 2 ? 'active' : ''}`} onClick={(e) => app.setActivePanelIndex(2)} style={buttonStyle}>
      //   <FontAwesomeIcon icon={faTasks} className="icon" />
      // </div>
      // <div className={`ripple btn ${activePanelIndex === 3 ? 'active' : ''}`} onClick={(e) => app.setActivePanelIndex(3)} style={buttonStyle}>
      //   <FontAwesomeIcon icon={faUsers} className="icon" />
      // </div>

      var buttonStyle = {
        width: "".concat(width, "px")
      };
      return React.createElement("div", {
        className: "mobile-navigation ".concat(this.state.collapsed ? 'collapsed' : 'expanded')
      }, React.createElement("div", {
        className: "tab-indicator"
      }, React.createElement("div", {
        className: "active-tab",
        style: {
          width: "".concat(tabWidth, "px"),
          marginLeft: "".concat(marginLeft, "px")
        }
      })), React.createElement("div", {
        className: "ripple btn ".concat(activePanelIndex === 0 && searchMode === 'location' ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setSearchMode('location');
        },
        style: buttonStyle
      }, React.createElement(FontAwesomeIcon, {
        icon: faMapMarked,
        className: "icon"
      })), React.createElement("div", {
        className: "ripple btn track-mode ".concat(activePanelIndex === 0 && searchMode === 'track' ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setSearchMode('track');
        },
        style: buttonStyle
      }, React.createElement(FontAwesomeIcon, {
        icon: faMapMarker,
        className: "map-marker"
      }), React.createElement(FontAwesomeIcon, {
        icon: faList,
        className: "list"
      })), window.BackgroundGeolocation && React.createElement("div", {
        className: "ripple btn ".concat(activePanelIndex === 0 && searchMode === 'trackLocator' ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setSearchMode('trackLocator');
        },
        style: buttonStyle
      }, React.createElement(FontAwesomeIcon, {
        icon: faLocationArrow,
        className: "icon"
      })), React.createElement("div", {
        className: "ripple btn ".concat(activePanelIndex === 1 ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setActivePanelIndex(1);
        },
        style: buttonStyle
      }, React.createElement(FontAwesomeIcon, {
        icon: faBook,
        className: "icon"
      })), React.createElement("div", {
        className: "ripple btn ".concat(activePanelIndex === 2 ? 'active' : ''),
        onClick: function onClick(e) {
          return app.setActivePanelIndex(2);
        },
        style: buttonStyle
      }, React.createElement(FontAwesomeIcon, {
        icon: faIdCard,
        className: "icon"
      })));
    }
  }]);

  return MobileNavigation;
}(React.PureComponent);

export default MobileNavigation;